// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__hmwIi","title":"ClientInsurance_title__3rH37","itemText":"ClientInsurance_itemText__m9Du3"};